'use es6';

import { TROUBLESHOOT_ENDPOINT } from 'MeetingsLib/constants/endpoints';
import { hubletAwareApi } from 'MeetingsLib/utils/utils';
export var fetchTroubleshootTimesRequest = function fetchTroubleshootTimesRequest(httpClient, slug, portalId) {
  return httpClient.get("" + TROUBLESHOOT_ENDPOINT, {
    ignoreRedirect: true,
    query: {
      slug: slug,
      portalId: portalId
    },
    api: hubletAwareApi
  });
};